import { Link } from 'react-router-dom';
import { BRAND } from '../constants/site';

export default function TopBar() {
  return (
    <div className="topbar">
      <div className="container topbar__inner">
        <p className="topbar__deal">
          <span className="topbar__tag">Limited Offer</span>
          <span>Save up to 60% on {BRAND} Total Protection — activation help included.</span>
        </p>
        <div className="topbar__links">
          <Link to="/refund-policy">Refunds</Link>
          <Link to="/contact">Support</Link>
        </div>
      </div>
    </div>
  );
}
